/* global axios */
import ApiClient from './ApiClient';

class BulkBroadcastsAPI extends ApiClient {
  constructor() {
    super('bulk_broadcasts', { accountScoped: true });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  previewSplit(params) {
    return axios.post(`${this.url}/preview_split`, params);
  }
}

export default new BulkBroadcastsAPI();
